module.exports = __webpack_public_path__ + "static/img/qhwc.97aa663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/qhwc.png
// module id = 112
// module chunks = 0